export default {
  get publicBaseUrl(): string {
    return process.env.VUE_APP_PUBLIC_BASE_URL || "";
  },
  get minInvestmentPrimary(): number {
    return parseInt(process.env.VUE_APP_MIN_INVESTMENT_PRIMARY || "0");
  },
  get minInvestmentSecondary(): number {
    return parseInt(process.env.VUE_APP_MIN_INVESTMENT_SECONDARY || "0");
  },
  get maxInvestment(): number {
    return parseInt(process.env.VUE_APP_MAX_INVESTMENT || "0");
  },
  get minWithdraw(): number {
    return parseInt(process.env.VUE_APP_MIN_WITHDRAW || "0");
  },
  get minReferralWithdraw(): number {
    return parseInt(process.env.VUE_APP_MIN_REFERRAL_WITHDRAW || "0");
  },
  get defaultInvestmentLimit(): number {
    return parseInt(process.env.VUE_APP_DEFAULT_INVESTMENT_LIMIT || "0");
  },
  get guarantorFeature(): boolean {
    return !!process.env.VUE_APP_GUARANTOR_FEATURE;
  },
  get reportsFeature(): boolean {
    return !!process.env.VUE_APP_REPORTS_FEATURE;
  },
  get platformInvestUserUuid(): string {
    // VUE_APP_LENDLY_INVEST_USER_UUID is the legacy name and is still what the
    // GitLab CI variable is called, so keep reading it as a fallback until that
    // is renamed in the project's CI/CD settings.
    return (
      process.env.VUE_APP_PLATFORM_INVEST_USER_UUID ||
      process.env.VUE_APP_LENDLY_INVEST_USER_UUID ||
      ""
    );
  },
  get avmUserUuid(): string {
    return process.env.VUE_APP_AVM_USER_UUID || "";
  },
  get gradinarUserUuid(): string {
    return process.env.VUE_APP_GRADINAR_USER_UUID || "";
  },
  get ramachevskiyUserUuid(): string {
    return process.env.VUE_APP_RAMACHEVSKIY_USER_UUID || "";
  },
  get salimovUserUuid(): string {
    return process.env.VUE_APP_SALIMOV_USER_UUID || "";
  },
  get standardProjectUuid(): string {
    return process.env.STANDARD_PROJECT_UUID || "";
  },
  get signatureTurnedOff(): boolean {
    return !!process.env.VUE_APP_TURN_OFF_SIGNATURE;
  },

  // ---------------------------------------------------------------------------
  // Externally hosted documents and channels.
  //
  // These were hardcoded across eight components. The defaults still point at
  // the Lendly CDN because that is where the files actually live and are served
  // (verified HTTP 200) — there is no 2-chance CDN yet (`2-chance.cdn.internal`
  // resolves but has no nginx vhost). Override per environment in .env once the
  // documents are re-hosted; no component changes needed.
  // ---------------------------------------------------------------------------
  get rulesDocUrl(): string {
    return (
      process.env.VUE_APP_DOC_RULES_URL ||
      "https://cdn.lendly.ru/rules-2024-06-25.pdf"
    );
  },
  get loyaltyDocUrl(): string {
    return (
      process.env.VUE_APP_DOC_LOYALTY_URL || "https://cdn.lendly.ru/loyal.pdf"
    );
  },
  get cryptoProGuideUrl(): string {
    return (
      process.env.VUE_APP_DOC_CRYPTOPRO_URL ||
      "https://cdn.lendly.ru/crypto-pro-intall-windows.pdf"
    );
  },
  get collateralAgreementTemplateUrl(): string {
    return (
      process.env.VUE_APP_DOC_COLLATERAL_AGREEMENT_URL ||
      "https://cdn.lendly.ru/loan_agreement.docx"
    );
  },
  get supportTgUrl(): string {
    return process.env.VUE_APP_SUPPORT_TG_URL || "https://t.me/lendlysupport";
  },
  get newsTgUrl(): string {
    return process.env.VUE_APP_NEWS_TG_URL || "https://t.me/lendly";
  },

  // ---------------------------------------------------------------------------
  // Legal identity shown in the footer.
  //
  // These were hardcoded in FooterMenu.vue as the literal placeholders
  // "тут инн" / "тут адрес регистрации" / "тут почта" — which rendered to every
  // visitor. There are no defaults on purpose: an empty value hides its line
  // rather than printing a placeholder. Fill these in before launch.
  // ---------------------------------------------------------------------------
  get companyName(): string {
    return process.env.VUE_APP_COMPANY_NAME || 'ООО "Второй шанс"';
  },
  get companyInn(): string {
    return process.env.VUE_APP_COMPANY_INN || "";
  },
  get companyAddress(): string {
    return process.env.VUE_APP_COMPANY_ADDRESS || "";
  },
  get supportEmail(): string {
    return process.env.VUE_APP_SUPPORT_EMAIL || "";
  },
  // The year the platform started operating — the left-hand side of the footer
  // copyright range. Previously hardcoded to 2026, which made the range read
  // "© 2026 - 2026".
  get copyrightStartYear(): number {
    return parseInt(process.env.VUE_APP_COPYRIGHT_START_YEAR || "2021");
  },
};
